import React from "react";

import styles from "./DashboardWidget.module.scss";

export const WidgetContainer: React.FC<
  { disabled?: boolean } & React.HTMLAttributes<HTMLDivElement>
> = ({ disabled, children, className, ...rest }) => (
  <div
    className={`${styles.widgetContainer} ${disabled ? styles.widgetContainerDisabled : ""} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);

export const DashboardCardContainer: React.FC<
  { disabled?: boolean } & React.HTMLAttributes<HTMLDivElement>
> = ({ disabled, children, className, ...rest }) => (
  <div
    className={`${styles.dashboardCardContainer} ${disabled ? styles.dashboardCardContainerDisabled : ""} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);
